import React from "react";
import { X, Check } from "lucide-react";
import { Checkbox } from "../ui/checkbox";

// Mobile Filter Modal Component
const MobileFilterModal = ({
  isOpen,
  onClose,
  sortOptions = [],
  sortValue,
  onSortChange,
  filterGroups = [],
  selectedFilters = [],
  onFilterChange,
  containerMode = false, // When true, renders within parent container instead of fixed viewport
}) => {
  const handleFilterChange = (filterKey) => {
    onFilterChange?.(filterKey);
  };

  return (
    <div className={`${containerMode ? 'absolute' : 'fixed'} inset-0 z-50 flex items-end justify-center transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-neutral-9 opacity-50" 
        onClick={onClose}
      />

      {/* Bottom Sheet - height based on content */}
      <div className={`relative w-full max-h-[80vh] bg-neutral-1 rounded-t-3xl z-10 flex flex-col transition-transform duration-300 ease-out ${isOpen ? 'translate-y-0' : 'translate-y-full'}`}>
        {/* Close button positioned at top of sheet */}
        <div className="absolute -top-14 left-1/2 transform -translate-x-1/2 z-20">
          <button
            onClick={onClose}
            className="w-10 h-10 bg-neutral-1 rounded-full shadow-lg flex items-center justify-center hover:bg-neutral-2 transition-colors"
          >
            <X className="w-5 h-5 text-neutral-8" />
          </button>
        </div>
        {/* Content */}
        <div className="p-5 overflow-y-auto">
          {/* Sort By Section */}
          {sortOptions.length > 0 && (
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-4">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="text-neutral-8"
                >
                  <path
                    d="M3 4.5h12M3 9h8M3 13.5h5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                <h3 className="text-base font-semibold text-neutral-10">Sort By</h3>
              </div>
              <div className="flex gap-3">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => onSortChange?.(option.value)}
                    className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                      sortValue === option.value
                        ? "bg-primary-3 text-neutral-1 border border-primary-3"
                        : "bg-neutral-1 text-neutral-8 border border-primary-3 hover:bg-neutral-2"
                    }`}
                  >
                    {sortValue === option.value && (
                      <Check className="w-4 h-4" />
                    )}
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Filter By Section */}
          {filterGroups.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-4">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="text-neutral-8"
                >
                  <path
                    d="M2.25 3.75h13.5l-5.25 6v4.5l-3 1.5v-6l-5.25-6z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h3 className="text-base font-semibold text-neutral-10">
                  Filter By
                </h3>
              </div>
              <div className="space-y-4">
                {filterGroups.map((filter) => (
                  <Checkbox
                    key={filter.key}
                    id={filter.key}
                    label={`${filter.label} (${filter.count})`}
                    checked={selectedFilters.includes(filter.key)}
                    onCheckedChange={() => handleFilterChange(filter.key)}
                    labelClassName="text-neutral-10 text-sm"
                    checkboxClasses="h-5 w-5 border-2"
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Export the component
export { MobileFilterModal };